import { Component, OnInit } from '@angular/core';
import { InvoiceDataService } from '../services/invoice-data.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { InvoiceModel } from '../models/InvoiceModels/invoices';
import { SearchPackage } from '../models/searchPackage';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.less']
})
export class InvoiceComponent implements OnInit {
  token : string;
  created : string;
  due : string;
  locationName : string;
  loaded : boolean = false;
  models : InvoiceModel[] = [];
  addyData : any;
  packages : SearchPackage[];
  constructor(public inv : InvoiceDataService,public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      this.token = p.get('token');
      this.inv.getDataForInvoice(this.token).subscribe((scc: any)=>{
        console.log(`got invoice data`, scc);
        this.created = scc.created;
        this.due = scc.due;
        this.addyData = scc.addyData;
        this.locationName = scc.models[0].locationName;
        this.packages = scc.packages;
        scc.models.forEach(element => {
          this.models.push(Object.assign(new InvoiceModel(),element));
        });
        
        this.loaded = true;
      })
    });
  }

}
